import dashboard from '../../images/icons/dashboard.png';
import report from '../../images/icons/reports.png';
import TeamLeaderPanel from '../components/TeamLeaderPanel';

const adminNavigationConfig = [
	{
		name: 'Dashboard',
		link: '/dashboard',
		path: dashboard,
		access: 'DASHBOARD',
	},
	{
		name: 'Contacts',
		link: '/dashboard/contacts',
		icon: 'address-book',
		access: 'CONTACT',
	},
	{
		name: 'Orders',
		link: '/dashboard/orders',
		icon: 'address-card',
		access: 'ORDER',
	},
	{
		name: 'Tickets',
		link: '/dashboard/tickets',
		icon: 'clipboard-list',
		access: 'TICKETS',
	},

	{
		name: 'Reports',
		icon: 'chart-simple',
		access: 'REPORTS',
		list: [
			{
				name: 'Sent Orders',
				link: '/report/sent-orders',
				icon: 'paper-plane',
				access: 'REPORTS_SENT_ORDERS',
			},
			{
				name: 'UTM',
				link: '/report/utm',
				icon: 'bullhorn',
				access: 'REPORTS_UTM',
			},
			{
				name: 'Not pick up calls',
				link: '/report/not-pick-up-calls',
				icon: 'phone',
				access: 'REPORTS_NOT_PICK_UP',
			},
			{
				name: 'Daily',
				link: '/report/daily',
				icon: 'users',
				access: 'REPORTS_DAILY',
			},
			{
				name: 'Daily Market',
				link: '/report/daily-market',
				icon: 'magnifying-glass-chart',
				access: 'REPORTS_DAILY_MARKET',
			},
			{
				name: 'Effectivity',
				link: '/report/effective',
				icon: 'chart-simple',
				access: 'REPORTS_EFFECTIVE',
			},
			{
				name: 'Payment',
				link: '/report/payment',
				icon: 'money',
				access: 'REPORTS_EFFECTIVE_SALARY',
			},
			// {
			// 	name: 'Grade',
			// 	link: '/report/grade',
			// 	icon: 'chart-simple',
			// 	access: 'REPORTS_GRADE',
			// },

			{
				name: 'Contacts road',
				link: '/report/contacts-road',
				icon: 'road',
				access: 'REPORTS_CONTACTS_ROAD',
			},
			{
				name: 'Call history',
				link: '/report/consultant',
				icon: 'user',
				access: 'REPORTS_CALLING_HISTORY',
			},
			{
				name: 'Cost per lead (Netto)',
				link: '/report/cost-per-lead',
				icon: 'money',
				access: 'REPORTS_CPL',
			},

			{
				name: 'Lang Pair Claim',
				link: '/report/lang-pair-claim',
				icon: 'road',
				access: 'REPORTS_LANG_PAIR',
			},
			{
				name: 'Lost packages',
				link: '/report/lost-packages',
				icon: 'road',
				access: 'REPORTS_LOST_PACAKAGE',
			},
			{
				name: 'Suspicions',
				link: '/report/suspicion',
				icon: 'circle-exclamation',
				access: 'REPORTS_SUSPICIONS',
			},
			{
				name: 'Product CPL(Netto)',
				link: '/report/product-cpl',
				icon: 'money',
				access: 'REPORTS_PRODUCT_CPL',
			},
			{
				name: 'Payment Product CPL(Netto)',
				link: '/report/payment-product-cpl',
				icon: 'money',
				access: 'REPORTS_PRODUCT_CPL',
			},
			{
				name: 'Resign',
				link: '/report/resign',
				icon: 'ban',
				access: 'REPORTS_RESIGN',
			},
			{
				name: 'Resign new',
				link: '/report/resign-new',
				icon: 'ban',
				access: 'REPORTS_RESIGN',
			},
			{
				name: 'Order lang stats',
				link: '/report/order-langs-stats',
				icon: 'language',
				access: 'REPORTS_ORDER_LANGS_STATS',
			},
			{
				name: 'Mails',
				link: '/report/mails',
				icon: 'envelope-circle-check',
				access: 'REPORTS_MAIL_CATEGORY',
			},
			{
				name: 'Profitability',
				link: '/report/profitability',
				icon: 'comments-dollar',
				access: 'REPORTS_PROFITABILITY',
			},
			{
				name: 'Quiz',
				link: '/report/quiz',
				icon: 'clipboard-question',
				access: 'REPORTS_QUIZ',
			},
			{
				name: 'Quiz Test',
				link: '/report/quiz-test',
				icon: 'clipboard-question',
				access: 'REPORTS_QUIZ_TEST',
			},
			{
				name: 'CC Weekly',
				link: '/report/cc-weekly',
				icon: 'calendar-week',
				access: 'REPORTS_CC_WEEKLY',
			},
			{
				name: 'Queue Leads Guessing',
				link: '/report/queue-leads-guessing',
				icon: 'question-circle',
				access: 'REPORTS_QUEUE_LEADS_GUESSING',
			},
			{
				name: 'Page Events',
				link: '/report/page-events',
				icon: 'elementor',
				access: 'REPORTS_PAGE_EVENTS',
			},
			{
				name: 'Employee KPI',
				link: '/report/employee-kpi',
				icon: 'chart-line',
				access: 'REPORTS_EMPLOYEE_KPI',
			},
			{
				name: 'Not Delivered Packages',
				link: '/report/not-delivered-packages',
				icon: 'boxes-packing',
				access: 'REPORTS_NOT_DELIVERED_PACKAGES',
			},
			{
				name: 'SERP Monitoring',
				link: '/report/serp-monitoring',
				icon: 'search',
				access: 'REPORTS_SERP_MONITORING',
			},
		],
	},

	{
		name: 'Mail',
		icon: 'envelope',
		access: 'MAIL',
		list: [
			{
				name: 'Search',
				link: '/mail/search',
				icon: 'envelope',
				access: 'MAIL_SEARCH',
			},
			{
				name: 'Template',
				link: '/mail/template',
				icon: 'file',
				access: 'MAIL_TEMPLATE_VIEW',
			},
			{
				name: 'Test',
				link: '/mail/test',
				icon: 'file',
				access: 'MAIL_TEST_VIEW',
			},
			{
				name: 'Category',
				link: '/mail/category',
				icon: 'list',
				access: 'MAIL_CATEGORY_VIEW',
			},
			{
				name: 'Recruitment category',
				link: '/mail/recruitment-mail',
				icon: 'list',
				access: 'MAIL_RECRUITMENT_CATEGORY',
			},
			{
				name: 'Attachments',
				link: '/mail/attachments',
				icon: 'paperclip',
				access: 'MAIL_ATTACHMENTS',
			},
		],
	},
	{
		name: 'Accounting',
		path: report,
		access: 'ACCOUNTING',
		list: [
			{
				name: 'Claim Search',
				link: '/hr/claim/search',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS_SEARCH',
			},
			{
				name: 'Claims',
				link: '/hr/claim/not_ended_claims',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS',
			},
			{
				name: 'Claims Report',
				link: '/hr/claims-report',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS_REPORT',
			},
			{
				name: 'Invoices',
				link: '/hr/invoices',
				icon: 'file-invoice',
				access: 'ACCOUNTING_INVOICES',
			},
			{
				name: 'Invoices Report',
				link: '/hr/invoices-report',
				icon: 'file-invoice-dollar',
				access: 'ACCOUNTING_INVOICES_REPORT',
			},
			{
				name: 'Valid invoices',
				link: '/valid-invoices',
				icon: 'file-invoice',
				access: 'VALID_INVOICES_GET',
			},
			{
				name: 'Valid Invoices Report',
				link: '/valid-invoices-report',
				icon: 'file-invoice-dollar',
				access: 'ACCOUNTING_INVOICES',
			},
			{
				name: 'Valid Claims',
				link: '/valid-claims',
				icon: 'receipt',
				access: 'VALID_CLAIMS_GET',
			},
			{
				name: 'Valid claims feedback',
				link: '/report/valid-claims-feedback-report',
				icon: 'comment',
				access: 'REPORTS_VALID_CLAIMS_FEEDBACK',
			},
			{
				name: 'Valid Claims Report',
				link: '/report/valid-claims-report',
				icon: 'file-invoice',
				access: 'REPORTS_VALID_CLAIMS',
			},
			{
				name: 'Payment Report',
				link: '/report/operator-payment-report',
				icon: 'file-invoice',
				access: 'OPERATOR_PAYMENT_REPORT',
			},
			{
				name: 'Refunds',
				link: '/refunds',
				icon: 'book',
				access: 'FIND_REFUNDS',
			},
		],
	},
	{
		name: 'Voip',
		icon: 'phone',
		access: 'VOIP',
		list: [
			{
				name: 'SMS Search',
				link: '/voip/sms/search',
				icon: 'sms',
				access: 'VOIP_SMS_SEARCH',
			},
			{
				name: 'SMS Create',
				link: '/voip/sms/create',
				icon: 'sms',
				access: 'VOIP_SMS_CREATE',
			},
			{
				name: 'Grading',
				link: '/voip/listening-marks',
				icon: 'ear-listen',
				access: 'VOIP_MARKS',
			},
			{
				name: 'Scoring listening',
				link: '/voip/listening-scoring',
				icon: 'headphones',
				access: 'VOIP_SCORING',
			},
			{
				name: 'Calling Search',
				link: '/voip/calling/search',
				icon: 'phone',
				access: 'VOIP_CALLING_SEARCH',
			},
			{
				name: 'Realtime',
				link: '/voip/realtime-dashboard',
				icon: 'home',
				access: 'VOIP_REALTIME',
			},
			{
				name: 'Working',
				link: '/voip/working-time',
				icon: 'clock',
				access: 'VOIP_WORKING_TIME',
			},
			{
				name: 'Statistics',
				link: '/voip/statistics',
				icon: 'chart-bar',
				access: 'VOIP_STATISTICS',
			},
			{
				name: 'Listening',
				link: '/voip/listening',
				icon: 'ear-listen',
				access: 'VOIP_LISTENING',
			},
			{
				name: 'AI Call Analysis',
				link: '/voip/call-analysis',
				icon: 'ear-listen',
				access: 'AI_CALL_ANALYSIS',
			},
			{
				name: 'AI Analysis Report',
				link: '/voip/call-analysis-report',
				icon: 'chart-bar',
				access: 'AI_CALL_ANALYSIS',
			},
			{
				name: 'AI Analysis Config',
				link: '/voip/call-analysis-config',
				icon: 'gear',
				access: 'AI_CALL_ANALYSIS',
			},
			{
				name: 'Scoring',
				link: '/voip/listening-scores',
				icon: 'star',
				access: 'VOIP_SCORING',
			},
			{
				name: 'Archive',
				link: '/voip/archive',
				icon: 'box-archive',
				access: 'VOIP_ARCHIVE',
			},
			{
				name: 'Calling Information',
				link: '/voip/calling-information',
				icon: 'circle-info',
				access: 'CALLING_INFORMATION_GET',
			},
		],
	},
	{
		name: 'CC',
		icon: 'headphones',
		access: 'CC',
		list: [
			{
				name: 'Hours',
				link: '/cc/hours',
				icon: 'clock-o',
				access: 'CC_HOURS',
			},
			{
				name: 'Hours report',
				link: '/cc/hours_report',
				icon: 'hourglass-end',
				access: 'CC_HOURS_REPORT',
			},
			{
				name: 'Payment',
				link: '/cc/payment',
				icon: 'money',
				access: 'CC_PAYMENT',
			},
			{
				name: 'Payment KDR',
				link: '/cc/payment_kdr',
				icon: 'money',
				access: 'CC_PAYMENT_KDR',
			},
			{
				name: 'Payment short',
				link: '/cc/payment-short',
				icon: 'money',
				access: 'CC_PAYMENT',
			},
			{
				name: 'Gamification',
				link: '/cc/gamification',
				icon: 'play',
				access: 'CC_GAMIFICATION',
			},
			{
				name: 'Gamification new',
				link: '/cc/gamification/new',
				icon: 'star',
				access: 'CC_GAMIFICATION',
			},
			{
				name: 'Payout slip',
				link: '/cc/payout-slip',
				icon: 'cash-register',
				access: 'CC_PAYMENT',
			},
			{
				name: 'Speech to text',
				link: '/cc/speech-to-text',
				icon: 'comment',
				access: 'CC_SPEECH_TO_TEXT',
			},
			{
				name: 'Recruitment',
				link: '/cc/recruitment',
				icon: 'users',
				access: 'CC_RECRUITMENT',
			},
			{
				name: 'Follow Up Shipments',
				link: '/cc/follow-up-shipments',
				icon: 'truck-ramp-box',
				access: 'CC_FOLLOW_UP_SHIPMENTS',
			},
			{
				name: 'Follow Up Payments',
				link: '/cc/follow-up-payments',
				icon: 'credit-card',
				access: 'CC_FOLLOW_UP_PAYMENTS',
			},
			{
				name: 'Files',
				link: '/cc/files',
				icon: 'file',
				access: 'CRM_SETTINGS_FILES',
			},
		],
	},
	{
		name: 'CRM settings',
		icon: 'gear',
		access: 'CRM_SETTINGS',
		list: [
			{
				name: 'Markets',
				link: '/settings/market/list',
				icon: 'location-dot',
				access: 'CRM_SETTINGS_MARKETS',
			},
			{
				name: 'Users',
				link: '/settings/user/list',
				icon: 'location-dot',
				access: 'CRM_SETTINGS_USERS',
			},
			{
				name: 'Queues',
				link: '/settings/queue/list',
				icon: 'chess-queen',
				access: 'CRM_SETTINGS_QUEUES',
			},
			{
				name: 'Products',
				link: '/settings/product/list',
				icon: 'product-hunt',
				access: 'CRM_SETTINGS_PRODUCTS',
			},
			{
				name: 'Super products',
				link: '/settings/super-product/list',
				icon: 'list',
				access: 'CRM_SETTINGS_SUPER_PRODUCTS',
			},
			{
				name: 'Instant Forms',
				link: '/settings/instant-forms/list',
				icon: 'id-card',
				access: 'CRM_SETTINGS_INSTANT_FORMS',
			},
			{
				name: 'Dictionary',
				link: '/settings/dictionary',
				icon: 'spell-check',
				access: 'CRM_SETTINGS_DICTIONARY',
			},
			{
				name: 'Blackboard',
				link: '/settings/blackboard/list',
				icon: 'chalkboard',
				access: 'CRM_SETTINGS_BLACKBOARD',
			},
			{
				name: 'FAQ',
				link: '/settings/faq/list',
				icon: 'question',
				access: 'CRM_SETTINGS_FAQ',
			},
			{
				name: 'Drafts',
				link: '/settings/drafts/list',
				icon: 'file',
				access: 'CRM_SETTINGS_DRAFTS',
			},
			{
				name: 'LI Gen',
				link: '/settings/listening-generator',
				icon: 'ear-listen',
				access: 'CRM_SETTINGS_LISTENING_GENERATOR',
			},
			{
				name: 'Meta',
				link: '/settings/meta',
				icon: 'meta',
				access: 'CRM_SETTINGS_META',
			},
			{
				name: 'Language',
				link: '/settings/languages',
				icon: 'globe',
				access: 'CRM_SETTINGS_LANGUAGE',
			},
			{
				name: 'Tests',
				link: '/settings/test/list',
				icon: 'question-circle',
				access: 'CRM_SETTINGS_TEST_GET_ALL',
			},
			{
				name: 'Gamification',
				link: '/settings/gamification',
				icon: 'star',
				access: 'CC_GAMIFICATION',
			},
			{
				name: 'Invoice Templates',
				link: '/settings/invoice-templates',
				icon: 'pen-ruler',
				access: 'CRM_SETTINGS_INVOICE_TEMPLATE',
			},
			{
				name: 'Keys',
				link: '/settings/keys',
				icon: 'key',
				access: 'CRM_SETTINGS_KEYS',
			},
			{
				name: 'Companies',
				link: '/settings/companies',
				icon: 'building',
				access: 'CRM_SETTINGS_COMPANY',
			},
			{
				name: 'Invoices config',
				link: '/settings/invoice-config',
				icon: 'font',
				access: 'CRM_SETTINGS_INVOICE_CONFIG',
			},
			{
				name: 'Server Refresh',
				link: '/settings/server-refresh',
				icon: 'server',
				access: 'CRM_SETTINGS_SERVER_REFRESH',
			},
			{
				name: 'Department',
				link: '/settings/department',
				icon: 'building',
				access: 'CRM_SETTINGS_DEPARTMENT',
			},
			{
				name: 'Bonus',
				link: '/settings/bonus',
				icon: 'gift',
				access: 'CRM_SETTINGS_BONUS',
			},
			{
				name: 'SERP monitoring',
				link: '/settings/serp-monitoring',
				icon: 'search',
				access: 'CRM_SETTINGS_SERP_MONITORING',
			},
			{
				name: 'Recruitment page',
				link: '/settings/recruitment-page',
				icon: 'users',
				access: 'CRM_SETTINGS_RECRUITMENT',
			},
			{
				name: 'Call center position',
				link: '/settings/call-center-position',
				icon: 'tag',
				access: 'CRM_SETTINGS_POSITION',
			},
			{
				name: 'Dynamic mail content',
				link: '/settings/dynamic-mail-content',
				icon: 'envelope-open',
				access: 'CRM_SETTINGS_DYNAMIC_MAIL_CONTENT',
			},
			{
				name: 'Dynamic mail attachment',
				link: '/settings/dynamic-mail-attachment',
				icon: 'envelope-open',
				access: 'CRM_SETTINGS_DYNAMIC_MAIL_ATTACHMENT',
			},
			{
				name: 'Promotion',
				link: '/settings/promotion',
				icon: 'funnel-dollar',
				access: 'CRM_SETTINGS_PROMOTION',
			},
			{
				name: 'Mailing Reports',
				link: '/settings/mailing-reports',
				icon: 'envelope',
				access: 'CRM_SETTINGS_MAILING_REPORTS',
			},
			{
				name: 'Spends',
				link: '/settings/spends',
				icon: 'money-bill',
				access: 'CRM_SETTINGS_SPEND',
			},
		],
	},
];

const consultantNavigationConfig = [
	{
		name: 'Dashboard',
		link: '/consultant/dashboard',
		icon: 'bi bi-grid-3x3-gap',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_statistics',
		link: '/consultant/statistics',
		icon: 'bar-chart',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_orders',
		link: '/consultant/orders',
		icon: 'address-book',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_salary',
		link: '/consultant/salary',
		icon: 'dollar',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Hours',
		link: '/consultant/hours',
		icon: 'clock-o',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Refunds',
		link: '/consultant/refunds',
		icon: 'book',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Tickets',
		link: '/consultant/tickets',
		icon: 'tasks',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Listening',
		link: '/consultant/listening',
		icon: 'ear-listen',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'FAQ',
		link: '/consultant/faq',
		icon: 'question',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Drafts',
		link: '/consultant/drafts',
		icon: 'file',
		access: 'CONSULTANT_COMMON',
	},
	// {
	//   name: "Tests",
	//   link: "/consultant/tests",
	//   icon: "check",
	//   access: "CONSULTANT_COMMON",
	// },
	// {
	//   name: "Gamification",
	//   link: "/consultant/gamification",
	//   icon: "fas gamepad",
	//   access: "CONSULTANT_COMMON",
	// },
	{
		name: 'Follow Up Shipments',
		link: '/consultant/follow-up-shipments',
		icon: 'truck-ramp-box',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Follow Up Payments',
		link: '/consultant/follow-up-payments',
		icon: 'credit-card',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Email',
		link: '/consultant/email',
		icon: 'envelope',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Your Team',
		icon: 'users',
		access: 'CONSULTANT_MANAGER',
		element: (setShow) => <TeamLeaderPanel setShow={setShow} />,
	},
];

export { adminNavigationConfig, consultantNavigationConfig };
